import {
  Authorized,
  Notifications,
  NotificationsContext,
  useNotifications,
} from '@evolve/common-ui';
import { notificationsApi, setupStore } from 'evolve-api';
import { NotificationContextProvider, UserContextProvider } from 'evolve-ui';
import { GatsbyBrowser } from 'gatsby';
import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';

// ! FIX ME: Remove this wrapper after migrating the components that rely on Notifications Context
const AppWrapper = ({ children }: { children: ReactNode }) => {
  const { notifications, addNotification, removeNotification } =
    useNotifications();

  return (
    <NotificationsContext.Provider
      value={{ notifications, addNotification, removeNotification }}
    >
      <Notifications />
      {children}
    </NotificationsContext.Provider>
  );
};

// * Wrap application with global providers here
// * Currently, react-redux store, user context and notifications context providers.
// * Add more as needed....
const ProviderWrapper: GatsbyBrowser['wrapRootElement'] = ({
  element,
}: {
  element: ReactNode;
}) => {
  // * APIs used on this project. Add more as needed...
  const apis = [notificationsApi];

  return (
    <Authorized>
      <Provider store={setupStore(apis)}>
        <NotificationContextProvider>
          <UserContextProvider>
            <AppWrapper>{element}</AppWrapper>
          </UserContextProvider>
        </NotificationContextProvider>
      </Provider>
    </Authorized>
  );
};

export default ProviderWrapper;
